import { render, staticRenderFns } from "./AuditLogsList.vue?vue&type=template&id=3b322d1e&scoped=true&"
import script from "./AuditLogsList.vue?vue&type=script&lang=js&"
export * from "./AuditLogsList.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogsList.vue?vue&type=style&index=0&id=3b322d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b322d1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTableHeader } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTableHeader})
